var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navigation-bar'),_c('nuxt',{key:_vm.$route.fullPath,staticStyle:{"min-height":"calc(100vh - 78px - 150px)"},attrs:{"keep-alive":""}}),_c('fixed-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }